import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=7540d15e&"
import script from "./OrderReports.vue?vue&type=script&lang=js&"
export * from "./OrderReports.vue?vue&type=script&lang=js&"
import style0 from "./OrderReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports